<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color} stroke-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M12.2291 12.0044L6.77783 6.62144L7.40716 6L13.4789 11.9956L7.40716 18L6.77783 17.3786L12.2291 11.9956L12.2291 12.0044ZM11.0768 17.3786L11.7061 18L17.7778 12.0044L11.7061 6.00875L11.0768 6.6302L16.528 12.0044L11.0768 17.3786Z"
      :class="colorClass"
      stroke-width="0.5"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
